import mapKnownValues from "../../utils/mapKnownValues";

export default class Resource {
  url = "";
  name = "";
  frontUrl = "";
  backUrl = "";

  constructor(params: Partial<Resource> = {}) {
    mapKnownValues(this, params);
  }

  // We want to show a title that looks good to the user, so remove _'s
  get sanitizedTitle() {
    const firstUnderScore = this.name.indexOf("_");
    if (firstUnderScore > -1) {
      return this.name.substring(0, this.name.indexOf("_"));
    }
    return this.name;
  }
}
